import React, { useState } from 'react';
import { Row, Col, Form } from 'antd';
// , Button
// import { useNavigate } from 'react-router-dom';
import styles from './styles.module.less';

const Edit = () => {
  // { setSelectedPlan }
  // const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('3 MONTHS');
  // const [selectedLoadingPlan, setSelectedLoadingPlan] = useState(null);

  // console.log('selectedLoadingPlan', selectedLoadingPlan);
  // Tabs Data //
  // const routes = {
  //   'About Me': '/editprofile',
  //   'Family Details': '/editfamily',
  //   'Education & Career': '/editeducation',
  //   Horoscope: '/edithoroscope',
  //   Contact: '/editcontact',
  //   'Desired Partner': '/editpartner',
  //   Membership: '/membership_payment'
  // };
  // const handleSectionClick = (section) => {
  //   if (routes[section]) {
  //     navigate(routes[section]);
  //   }
  // };
  // const activeTabb = Object.entries(routes).find(
  //   ([, path]) => location.pathname === path
  // )?.[0];

  // Tabs Data

  // const userData = JSON.parse(localStorage.getItem('MAT-User'));
  // const isLoggedIn = userData && userData.accessToken ? true : false;
  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const userName =
  //   matUserObject?.user_details?.first_name +
  //   ' ' +
  //   matUserObject?.user_details?.last_name;

  // const onSelectPlan = (plan) => {
  //   setSelectedLoadingPlan(plan.title);
  //   setSelectedPlan({
  //     title: plan.title,
  //     price: plan.price,
  //     billingFrequency: activeTab
  //   });
  // };

  const pricingData = {
    '3 MONTHS': [
      {
        title: 'SPECIALIZED',
        price: 'INR 0',
        priceN: 'INR 5000',
        tag: 'Actucl Price <del>INR 5000</del> per user',
        badge: 'Save 100%',
        // tag: 'GST extra as applicable',
        features: [
          'View up to 3x profiles daily',
          'Connect directly with matches',
          // 'Unlimited voice and video calls',
          'Unlimited chats',
          'Be featured under spotlight',
          'Download 3 profiles'
        ]
      },
      {
        title: 'ELITE',
        price: 'INR 0',
        priceN: 'INR 22500',
        tag: 'Actucl Price <del>INR 22500</del> per user',
        badge: 'Save 100%',
        // tag: 'GST extra as applicable',
        features: [
          'View up to 5x profiles daily',
          'Connect directly with matches',
          // 'Unlimited voice and video calls',
          'Unlimited chats',
          'Be featured under spotlight',
          'Download 3 profiles',
          'Priority support',
          'AI assisted matching and profiling'
        ]
      }
    ],
    '6 MONTHS': [
      {
        title: 'SPECIALIZED',
        price: 'INR 0',
        // price: 'INR 9000',
        tag: 'Actucl Price <del>INR 9000</del> per user',
        badge: 'Save 100%',
        // tag: 'GST extra as applicable',
        features: [
          'View up to 3x profiles daily',
          'Connect directly with matches',
          // 'Unlimited voice and video calls',
          'Unlimited chats',
          'Be featured under spotlight',
          'Download 6 profiles'
        ]
      },
      {
        title: 'ELITE',
        price: 'INR 0',
        // price: 'INR 40000',
        tag: 'Actucl Price <del>INR 40000</del> per user',
        badge: 'Save 100%',
        // tag: 'GST extra as applicable',
        features: [
          'View up to 5x profiles daily',
          'Connect directly with matches',
          // 'Unlimited voice and video calls',
          'Unlimited chats',
          'Be featured under spotlight',
          'Download 6 profiles',
          'Priority support',
          'AI assisted matching and profiling'
        ]
      }
    ],
    '12 MONTHS': [
      {
        title: 'SPECIALIZED',
        price: 'INR 0',
        // price: 'INR 17000',
        tag: 'Actucl Price <del>INR 17000</del> per user',
        badge: 'Save 100%',
        // tag: 'GST extra as applicable',
        features: [
          'View up to 3x profiles daily',
          'Connect directly with matches',
          // 'Unlimited voice and video calls',
          'Unlimited chats',
          'Be featured under spotlight',
          'Download 12 profiles'
        ]
      },
      {
        title: 'ELITE',
        price: 'INR 0',
        // price: 'INR 65000',
        tag: 'Actucl Price <del>INR 65000</del> per user',
        badge: 'Save 100%',
        // tag: 'GST extra as applicable',
        features: [
          'View up to 5x profiles daily',
          'Connect directly with matches',
          // 'Unlimited voice and video calls',
          'Unlimited chats',
          'Be featured under spotlight',
          'Download 12 profiles',
          'Priority support',
          'AI assisted matching and profiling'
        ]
      }
    ]
  };

  // const percent = user_data?.user_score;
  // const conicColors = {
  //   '0%': '#87d068',
  //   '50%': '#ffe58f',
  //   '100%': '#ffccc7'
  // };
  // const getStrokeColor = (percent) => {
  //   if (percent <= 30) return '#ff4d4f'; // Red
  //   if (percent <= 50) return '#fa8c16'; // Orange
  //   if (percent <= 80) return '#fadb14'; // Yellow
  //   return '#52c41a'; // Green
  // };

  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const profile_unique_id = matUserObject?.user_details?.profile_unique_id;

  const formattedPrice = (priceString) => {
    if (!priceString) return '';

    const parts = priceString.split(' '); // Split "INR 1000" → ["INR", "1000"]
    if (parts.length !== 2) return priceString; // Return original if format is incorrect

    const currency = parts[0] === 'INR' ? '₹' : parts[0]; // Convert "INR" to ₹
    const amount = parseFloat(parts[1]); // Convert "1000" → 1000 (number)

    return `${currency} ${new Intl.NumberFormat('en-IN').format(amount)}`;
  };

  return (
    <div className={styles.maincontainer}>
      <div className={styles.editOuter}>
        {/* <div className={styles.ButtonSet}>
          <button className={styles.primaryButton}>Back</button>
        </div> */}
        <div className={styles.singleContainer}>
          <Row
            gutter={24}
            style={{ width: '100%' }}
            className={styles.aboutimgstyles}
          >
            <Col
              xl={7}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.leftimgcontainer}>
                {/* <img src={LeftImg} /> */}
                <div className={styles.overlayText}>
                  <h2 className={styles.title}>THE TALE OF</h2>
                  <h1 className={styles.bigTitle}>TWO</h1>
                </div>
              </div>
            </Col>
            <Col
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.detailSide}>
                <div className={styles.detailName}>
                  <div className={styles.nameflex}>
                    <div className={styles.idname}>
                      {/* <h1 className={styles.dName}> {userName} </h1> */}
                      {/* {userName && <h1 className={styles.dName}>{userName}</h1>} */}
                      {/* <span> {profile_unique_id} </span> */}
                    </div>
                    {/* <div className={styles.matchpercent}>
                      <h6>
                        <span>96%</span> Away to find the right match
                      </h6>
                    </div> */}
                    {/* <Row gutter={[8, 8]} wrap>
                      <Col className={styles.progressname}>
                        <Progress
                          size="small"
                          type="circle"
                          percent={percent}
                          // strokeColor={conicColors}
                          strokeColor={getStrokeColor(percent)}
                        />
                        <h6 className={styles.matchpercent}>
                          away to find your life partner
                        </h6>
                      </Col>
                    </Row> */}
                  </div>
                  <div className={styles.changes}>
                    {/* <div className={styles.textContainer}>
                      <img
                        src={EditIcon}
                        alt="Edit Profile"
                        className={styles.icon}
                      />
                      <div>Edit</div>
                    </div> */}

                    {/* <div className={styles.vBorder}></div>

                    <div className={styles.textContainer}>
                      <img
                        src={downloadIcon}
                        alt="Download Profile"
                        className={styles.icon}
                      />
                      <div>Download</div>
                    </div> */}
                  </div>
                </div>
                <div>
                  <div className={styles.detailsOuter}>
                    <div className={styles.detailsInner}>
                      <div className={styles.detailsInside}>
                        {/* Tabs Content */}
                        {/* <div className={styles.searchTab}>
                          {Object.keys(routes).map((section) => (
                            <div
                              key={section}
                              className={`${styles.searchTabHeader} ${
                                activeTabb === section ? styles.activeTabb : ''
                              }`}
                              onClick={() => handleSectionClick(section)}
                            >
                              {section}
                            </div>
                          ))}
                        </div> */}
                        {/* Tabs Content */}
                        {/* Pricing Plans */}
                        <Form>
                          {/* onFinish={onFinish} */}
                          <div className={styles.tabs}>
                            {Object.keys(pricingData).map((tab) => (
                              <button
                                key={tab}
                                className={
                                  activeTab === tab ? styles.activeTab : ''
                                }
                                onClick={() => setActiveTab(tab)}
                              >
                                {tab}
                              </button>
                            ))}
                          </div>

                          <div className={styles.row}>
                            {pricingData[activeTab]?.map((plan) => (
                              <div key={plan.title} className={styles.col}>
                                <div className={styles.badgeOverlay}>
                                  <span className={styles.bad}>
                                    Limited Time Offer
                                  </span>
                                </div>
                                <h3 className={styles.pricetitle}>
                                  {plan.title}
                                </h3>
                                <p className={styles.price}>
                                  <span className={styles.mainPrice}>
                                    {formattedPrice(plan.price)}
                                  </span>
                                  <span className={styles.additionalText}>
                                    {' '}
                                    per user
                                  </span>
                                </p>

                                {plan.badge && (
                                  <div
                                    style={{
                                      backgroundColor: '#D20B0B',
                                      color: 'white',
                                      display: 'inline-block',
                                      padding: '0 8px',
                                      borderRadius: '10px',
                                      fontWeight: '12px',
                                      fontSize: '10px'
                                      // marginBottom: '8px'
                                    }}
                                  >
                                    {plan.badge}
                                  </div>
                                )}

                                <p className={styles.tagStyles}>
                                  {/* {plan.tag || ''} */}
                                  {plan.tag && (
                                    <p
                                      style={{
                                        // color: '#FF6403',
                                        color: 'rgba(210, 11, 11, 0.5)',
                                        textAlign: 'center'
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: plan.tag
                                      }}
                                    />
                                  )}
                                </p>
                                <Form.Item
                                  name="selectedPlan"
                                  style={{ display: 'none' }}
                                >
                                  <input type="hidden" />
                                </Form.Item>
                                <div
                                  className={styles.list}
                                  style={{ paddingLeft: '20px' }}
                                >
                                  <ul className={styles.features}>
                                    {plan.features.map((feature, index) => (
                                      <li key={index}>{feature}</li>
                                    ))}
                                  </ul>
                                  {/* {isLoggedIn ? (
                                    <Button
                                      type="primary"
                                      // htmlType="submit"
                                      className={styles.btn}
                                      onClick={() => onSelectPlan(plan)}
                                      // onClick={handleClick}
                                      // onClick={() => form.setFieldsValue({ selectedPlan: plan })}
                                      // onClick={() => onSelectPlan(plan)}
                                    >
                                      Subscribe
                                    </Button>
                                  ) : (
                                    navigate('/login')
                                  )} */}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Form>

                        {/*  */}
                      </div>
                    </div>
                    {/* </Form> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Edit;
